var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"local_fulfillment"},[_c('StudyLocalFulfillmentComponent',{attrs:{"msg":"空間知能化のお勉強"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }